module.exports = __webpack_public_path__ + "media/1.7aa48e00.mp3";